import { render, staticRenderFns } from "./importPublic.vue?vue&type=template&id=f4acf80e"
import script from "./importPublic.vue?vue&type=script&lang=js"
export * from "./importPublic.vue?vue&type=script&lang=js"
import style0 from "./importPublic.vue?vue&type=style&index=0&id=f4acf80e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports